/**
 * This will convert a camelCase string to Title Case.
 *
 * * "thisAttributeOfMine" -> "this Attribute Of Mine"
 */
export const toTitleCase = (text: string) => text
  .replace(/([A-Z])/g, ' $1')
  .replace(/ {2}/g, ' ')
  .trim();

/**
 * This will capitalize the first character of the string.
 *
 * * "capitalize" -> "Capitalize"
 * * "the fox jumped over the fence" -> "The fox jumped over the fence"
 */
export const capitalize = (text: string) => text.charAt(0).toUpperCase() + text.substring(1, text.length);

/**
 * This is a supplement to includes. `string.includes` will only check one
 * value, while this will check all items in the array.
 */
export const includesAny = (text: string, array: string[]) => {
  // eslint-disable-next-line
  for (let item of array) {
    if (text.includes(item)) { return true; }
  }

  return false;
};
